import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, notification, DatePicker, Space, message, Card, Select } from "antd";
import { Row, Form, Col } from "antd";
import { DownloadOutlined, FilterOutlined, ClearOutlined, SearchOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx';

import TopHeader from "../common/TopHeader/TopHeader";
import Sidebar from "../common/Sidebar/Sidebar";
import dayjs from "dayjs";
import jsPDF from 'jspdf';
import StockApi from "../common/Apis/StockApi";
import ReportsApi from "../common/Apis/ReportsApi";


const InventoryReports = () => {
    const { Content } = Layout;
    const [formAdd] = Form.useForm();
    const [WasteReport, setWasteReport] = React.useState([]);
    const [filteredReport, setFilteredReport] = React.useState([]);
    const [TotalQuantity, setTotalQuantity] = React.useState();
    const [TotalcostPriceUoM1, setTotalcostPriceUoM1] = React.useState();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";

    const [totalValue, setTotalValue] = useState(0);
    const [totalValue2, setTotalValue2] = useState(0);
    const [totalValue3, setTotalValue3] = useState(0);
    const [totalValue4, setTotalValue4] = useState(0);

    const [TotalGood, setTotalGood] = React.useState(0);
    const [exportLoading, setExportLoading] = useState(false);
    const [filterLoading, setFilterLoading] = useState(false);
    const [openingStock, setOpeningStock] = useState(0);
    const [openingStockLoading, setOpeningStockLoading] = useState(false);
    const [closingStock, setClosingStock] = useState(0);

    // Filter states
    const [departmentFilter, setDepartmentFilter] = useState(null);
    const [batchCodeFilter, setBatchCodeFilter] = useState(null);
    const [productNameFilter, setProductNameFilter] = useState(null);
    const [ddNumberFilter, setDdNumberFilter] = useState(null);

    // Unique filter options
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [batchOptions, setBatchOptions] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [ddNumberOptions, setDdNumberOptions] = useState([]);

    const topScrollRef = useRef(null);
    const tableScrollRef = useRef(null);

    const isFilterApplied =
        departmentFilter ||
        ddNumberFilter ||
        productNameFilter ||
        batchCodeFilter;

    const displayData = isFilterApplied ? filteredReport : WasteReport;


    useEffect(() => {
        const top = topScrollRef.current;
        const table = tableScrollRef.current;

        if (!top || !table) return;

        const topInner = top.firstChild;

        const syncTop = () => {
            table.scrollLeft = top.scrollLeft;
        };

        const syncTable = () => {
            top.scrollLeft = table.scrollLeft;
        };

        const updateWidth = () => {
            if (topInner) {
                topInner.style.width = `${table.scrollWidth}px`;
            }
        };

        updateWidth();

        top.addEventListener("scroll", syncTop);
        table.addEventListener("scroll", syncTable);
        window.addEventListener("resize", updateWidth);

        return () => {
            top.removeEventListener("scroll", syncTop);
            table.removeEventListener("scroll", syncTable);
            window.removeEventListener("resize", updateWidth);
        };
    }, [displayData]);

    // Helper functions to preserve the selected date in GMT
    const getGmtStartOfDay = (date) => {
        if (!date) return null;
        const d = dayjs(date);
        return dayjs.utc()
            .year(d.year())
            .month(d.month())
            .date(d.date())
            .startOf('day')
            .valueOf();
    };

    const getGmtEndOfDay = (date) => {
        if (!date) return null;

        const d = dayjs(date);

        return dayjs.utc()
            .year(d.year())
            .month(d.month())
            .date(d.date())
            .add(1, 'day')
            .startOf('day')
            .valueOf();
    };

     // Check whether stockList.createdDate is within the selected date range
    const isStockCreatedDateInRange = (stock) => {
        const startDate = formAdd.getFieldValue("startDate");
        const endDate = formAdd.getFieldValue("endDate");

        if (!startDate || !endDate || !stock?.createdDate) {
            return false;
        }

        const stockCreatedDate = Number(stock.createdDate);

        const startEpoch = getGmtStartOfDay(startDate);
        const endEpoch = getGmtEndOfDay(endDate);

        return (
            stockCreatedDate >= startEpoch &&
            stockCreatedDate < endEpoch
        );
    };

    useEffect(() => {
    if (!displayData || displayData.length === 0) {
        setTotalValue(0);
        setTotalValue2(0);
        setTotalValue3(0);
        setTotalValue4(0);
        return;
    }

   
    
    let computedTotal = 0;   // Goods Inward CP1
    let computedTotal2 = 0;  // Goods Outward
    let computedTotal3 = 0;  // Stock (available)
    let computedTotal4 = 0;  // Stock (available)

    displayData.forEach((date) => {
        const stockList = date?.goodsInwardDTO?.stockList || [];
        stockList.forEach((stock) => {
            const costPrice =
                parseFloat(stock?.productDTOs?.[0]?.costPriceUoM2) || 0;

            const initQuantity =
                parseFloat(stock?.initQuantity) || 0;

            const availableQty =
                parseFloat(stock?.unitOfMeasurement1) || 0;

            const usedQty =
                parseFloat(stock?.usedQuantity) || 0;

            const usedCost =
                parseFloat(stock?.usedCost) || 0;

            // Goods Inward: only stock created within selected date range
            if (isStockCreatedDateInRange(stock)) {

                computedTotal += initQuantity * costPrice;

            }

            // This Week Usage: use API values directly
            computedTotal2 += usedCost;

            // Available Stock
            computedTotal3 += availableQty * costPrice;

            // Goods Outward
            computedTotal4 += (initQuantity - availableQty) * costPrice;

        });

    });

    setTotalValue(computedTotal);
    setTotalValue2(computedTotal2);
    setTotalValue3(computedTotal3);
    setTotalValue4(computedTotal4);

}, [displayData]);

    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    // Extract unique filter options from data
    const extractFilterOptions = (data) => {
        const departments = new Set();
        const batches = new Set();
        const products = new Set();
        const ddNumbers = new Set();

        data.forEach((item) => {
            if (item?.goodsInwardDTO?.institutionDTO?.institutionName) {
                departments.add(item.goodsInwardDTO.institutionDTO.institutionName);
            }
            
            if (item?.goodsInwardDTO?.deliveryDocketNumber) {
                ddNumbers.add(item.goodsInwardDTO.deliveryDocketNumber);
            }

            const stockList = item?.goodsInwardDTO?.stockList || [];
            stockList.forEach((stock) => {
                if (stock?.productDTOs?.[0]?.productName) {
                    products.add(stock.productDTOs[0].productName);
                }
                if (stock?.batchCode) {
                    batches.add(stock.batchCode);
                }
            });
        });

        setDepartmentOptions(Array.from(departments).sort());
        setBatchOptions(Array.from(batches).sort());
        setProductOptions(Array.from(products).sort());
        setDdNumberOptions(Array.from(ddNumbers).sort());
    };

    const applyFilters = useCallback((data) => {
        if (!data) {
            setFilteredReport([]);
            return;
        }

        const filtered = data
            .map(item => {
                let stockList = item?.goodsInwardDTO?.stockList || [];

                if (productNameFilter) {
                    stockList = stockList.filter(stock =>
                        stock?.productDTOs?.[0]?.productName === productNameFilter
                    );
                }

                if (batchCodeFilter) {
                    stockList = stockList.filter(stock =>
                        stock?.batchCode === batchCodeFilter
                    );
                }

                return {
                    ...item,
                    goodsInwardDTO: {
                        ...item.goodsInwardDTO,
                        stockList
                    }
                };
            })
            .filter(item => {
                if (item.goodsInwardDTO.stockList.length === 0) {
                    return false;
                }

                if (
                    departmentFilter &&
                    item.goodsInwardDTO.institutionDTO?.institutionName !== departmentFilter
                ) {
                    return false;
                }

                if (
                    ddNumberFilter &&
                    item.goodsInwardDTO.deliveryDocketNumber !== ddNumberFilter
                ) {
                    return false;
                }

                return true;
            });

        setFilteredReport(filtered);
    }, [
        departmentFilter,
        ddNumberFilter,
        productNameFilter,
        batchCodeFilter
    ]);

    // Apply filters when filter values change
    useEffect(() => {
        if (WasteReport.length > 0) {
            applyFilters(WasteReport);
        }
    }, [WasteReport, applyFilters]);

    // Handle start date change - auto set end date to next Monday
    const handleStartDateChange = (date) => {
        formAdd.setFieldsValue({
            startDate: date
        });
    };

    const handleEndDateChange = (date) => {
        formAdd.setFieldsValue({
            endDate: date
        });
    };

    const handlePrintButtonClick2 = () => {
        const windowWidth = window.innerWidth * 0.264583;
        const windowHeight = window.innerHeight * 0.264583;

        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: [windowWidth, windowHeight]
        });

        const fontSize = 12;
        const margin = 5;
        const cellWidthFactor = 0.24;
        const cellHeightFactor = 0.2;
        const thPaddingBottom = 0;

        doc.setFontSize(fontSize);

        const table = document.querySelector('.table');
        const rows = table.querySelectorAll('tr');

        const pageTitle = 'Inventory Report';
        const pageTitleWidth = doc.getStringUnitWidth(pageTitle) * fontSize / doc.internal.scaleFactor;
        const pageTitleXPos = (doc.internal.pageSize.width - pageTitleWidth) / 2;
        doc.text(pageTitleXPos, margin, pageTitle);

        doc.setFontSize(fontSize);
        const currentDate = new Date().toLocaleString();
        const dateTimeWidth = doc.getStringUnitWidth(currentDate) * fontSize / doc.internal.scaleFactor;
        const dateTimeXPos = doc.internal.pageSize.width - margin - dateTimeWidth;
        doc.text(dateTimeXPos, margin, currentDate);

        let yPos = margin + fontSize;

        rows.forEach((row, rowIndex) => {
            const cells = row.querySelectorAll('th, td');
            let xPos = margin;

            let maxRowspan = 1;
            cells.forEach((cell) => {
                const rowspan = cell.getAttribute('rowspan');
                if (rowspan && parseInt(rowspan) > maxRowspan) {
                    maxRowspan = parseInt(rowspan);
                }
            });

            let rowHeight = row.offsetHeight * cellHeightFactor;
            if (rowIndex === 1) {
                rowHeight *= 1;
            }
            rowHeight *= maxRowspan + 0.5;

            cells.forEach((cell, cellIndex) => {
                const cellText = cell.textContent.trim();
                const cellWidth = cell.offsetWidth * cellWidthFactor;

                const wrappedText = doc.splitTextToSize(cellText, cellWidth - 2);
                const textHeight = wrappedText.length * (fontSize / 2.2);

                if (yPos + textHeight > doc.internal.pageSize.height - margin) {
                    doc.addPage();
                    yPos = margin + fontSize;
                    doc.text(pageTitleXPos, margin, pageTitle);
                    doc.text(dateTimeXPos, margin, currentDate);
                }

                const isHeader = cell.tagName.toLowerCase() === 'th';
                doc.setFont(undefined, isHeader ? 'bold' : 'normal');

                const cellPadding = 0.5;
                let xPosAlign = xPos + cellPadding;

                doc.rect(xPos, yPos, cellWidth, rowHeight);
                doc.text(wrappedText, xPosAlign + 1, yPos + (isHeader ? thPaddingBottom + 5 : 5));

                xPos += cellWidth;
            });

            yPos += rowHeight;
        });

        window.open(doc.output('bloburl'), '_blank');
    };

    // Function to fetch opening AND closing stock
    const fetchStockData = useCallback(async (startDate, endDate) => {
        if (!startDate || !endDate) return;

        setOpeningStockLoading(true);
        try {
            const openingStartEpoch = getGmtStartOfDay(dayjs(startDate));
            const closingEndEpoch = getGmtEndOfDay(dayjs(endDate));

            const openingResponse = await ReportsApi.DashboardOpeningStock(openingStartEpoch, closingEndEpoch);
            if (openingResponse?.payload) {
                const openingValue = openingResponse.payload.openingStockValue || 0;
                const closingValue = openingResponse.payload.closingStockValue || 0;
                setOpeningStock(openingValue);
                setClosingStock(closingValue);
            }

            return { 
                openingStock: openingResponse?.payload?.openingStockValue || 0,
                closingStock: openingResponse?.payload?.closingStockValue || 0
            };
        } catch (error) {
            console.error("Error fetching stock data:", error);
            return { openingStock: 0, closingStock: 0 };
        } finally {
            setOpeningStockLoading(false);
        }
    }, []);

    // Function to handle export to Excel from current table data
    const handleExportToExcel = () => {
        const dataToExport = filteredReport.length > 0 ? filteredReport : WasteReport;
        
        if (!dataToExport || dataToExport.length === 0) {
            message.warning("No data available to export");
            return;
        }

        setExportLoading(true);

        try {
            const excelData = [];

            excelData.push({
                'Date': 'OPENING STOCK',
                'D.D Number': '',
                'Department Name': '',
                'Supplier Name': '',
                'Batch Code': '',
                'Product Name': `As of ${formAdd.getFieldValue('startDate') ? dayjs(formAdd.getFieldValue('startDate')).format('DD/MM/YYYY') : ''}`,
                'Added Qty (UOM2)': '',
                'Cost (UOM2) - Inward': `${CURRENCY} ${CurrencyConvert(openingStock)}`,
                'Used Qty (UOM2)': '',
                'Cost (UOM2) - Outward': '',
                'Available Qty (UOM2)': '',
                'Cost (UOM2) - Stock': ''
            });

            excelData.push({});

            let filteredTotalValue = 0;
            let filteredTotalValue2 = 0;
            let filteredTotalValue3 = 0;

            dataToExport.forEach((date) => {
                const stockList = date?.goodsInwardDTO?.stockList || [];
                stockList.forEach((stock, innerIndex) => {
                    const costPrice = parseFloat(stock?.productDTOs?.[0]?.costPriceUoM2) || 0;

                    const initQuantity = parseFloat(stock?.initQuantity) || 0;
                    const availableQty = parseFloat(stock?.unitOfMeasurement1) || 0;
                    const usedQty =   (parseFloat(stock?.usedQuantity) || 0);
                    const usedCost =  (parseFloat(stock?.usedCost) || usedQty * costPrice);

                    const inwardValue =  initQuantity * costPrice;
                    const outwardValue = (initQuantity - availableQty) * costPrice;
                    const stockValue = availableQty * costPrice;

                    filteredTotalValue += inwardValue;
                    filteredTotalValue2 += outwardValue;
                    filteredTotalValue3 += stockValue;

                    excelData.push({
                        'Date': innerIndex === 0 ? formatDate(date?.goodsInwardDTO?.goodInwardCreateDate) : '',
                        'D.D Number': innerIndex === 0 ? date?.goodsInwardDTO?.deliveryDocketNumber || '-' : '',
                        'Department Name': innerIndex === 0 ? date?.goodsInwardDTO?.institutionDTO?.institutionName || '-' : '-',
                        'Supplier Name': innerIndex === 0 ? date?.goodsInwardDTO?.supplierDTO?.supplierName || '-' : '-',
                        'Batch Code': stock?.batchCode || '-',
                        'Product Name': stock?.productDTOs?.[0]?.productName,
                        'Added Qty (UOM2)':  `${initQuantity} ${stock?.unit || ''}`,
                        'Cost (UOM2) - Inward':  `${CURRENCY} ${CurrencyConvert(inwardValue)}`,
                        'Used Qty (UOM2)': `${(initQuantity - availableQty).toFixed(2)} ${stock?.unit || ''}`,
                        'Cost (UOM2) - Outward': `${CURRENCY} ${CurrencyConvert(outwardValue)}`,
                        'Available Qty (UOM2)': `${availableQty} ${stock?.unit || ''}` ,
                        'Cost (UOM2) - Stock': `${CURRENCY} ${CurrencyConvert(stockValue)}` ,
                        'This Week Used Qty (UOM2)': `${usedQty} ${stock?.unit || ''}`,
                        'This Week Used Cost (UOM2)':`${CURRENCY} ${CurrencyConvert(usedCost)}` ,
                    });
                });
            });

            excelData.push({
                'Date': 'CLOSING STOCK',
                'D.D Number': '',
                'Department Name': '',
                'Supplier Name': '',
                'Batch Code': '',
                'Product Name': `As of ${formAdd.getFieldValue('endDate') ? dayjs(formAdd.getFieldValue('endDate')).format('DD/MM/YYYY') : ''}`,
                'Added Qty (UOM2)': '',
                'Cost (UOM2) - Inward': `${CURRENCY} ${CurrencyConvert(closingStock)}`,
                'Used Qty (UOM2)': '',
                'Cost (UOM2) - Outward': '',
                'Available Qty (UOM2)': '',
                'Cost (UOM2) - Stock': ''
            });

            excelData.push({});
            
            excelData.push({
                'Date': '',
                'D.D Number': '',
                'Department Name': '',
                'Supplier Name': '',
                'Batch Code': '',
                'Product Name': 'TOTAL',
                'Added Qty (UOM2)': '',
                'Cost (UOM2) - Inward': `${CURRENCY} ${CurrencyConvert(filteredTotalValue)}`,
                'Used Qty (UOM2)': '',
                'Cost (UOM2) - Outward': `${CURRENCY} ${CurrencyConvert(filteredTotalValue2)}`,
                'Available Qty (UOM2)': '',
                'Cost (UOM2) - Stock': `${CURRENCY} ${CurrencyConvert(filteredTotalValue3)}`
            });

            const ws = XLSX.utils.json_to_sheet(excelData);

            const colWidths = [
                { wch: 12 }, { wch: 15 }, { wch: 20 }, { wch: 20 },
                { wch: 15 }, { wch: 25 }, { wch: 18 }, { wch: 15 },
                { wch: 18 }, { wch: 15 }, { wch: 18 }, { wch: 15 }
            ];
            ws['!cols'] = colWidths;

            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const address = XLSX.utils.encode_col(C) + '1';
                if (!ws[address]) continue;
                ws[address].s = {
                    font: { bold: true, sz: 12, color: { rgb: "FFFFFF" } },
                    fill: { fgColor: { rgb: "4F81BD" }, patternType: "solid" },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }

            const lastRow = excelData.length;
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const address = XLSX.utils.encode_col(C) + lastRow;
                if (!ws[address]) continue;
                ws[address].s = {
                    font: { bold: true, sz: 11 },
                    fill: { fgColor: { rgb: "FFC000" }, patternType: "solid" },
                    alignment: { horizontal: "center", vertical: "center" }
                };
            }

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Inventory Report");

            const startDate = formAdd.getFieldValue('startDate');
            const endDate = formAdd.getFieldValue('endDate');
            let fileName = `Inventory_Report_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;

            if (startDate && endDate) {
                const startStr = dayjs(startDate).format('YYYY-MM-DD');
                const endStr = dayjs(endDate).format('YYYY-MM-DD');
                fileName = `Inventory_Report_${startStr}_to_${endStr}.xlsx`;
            }

            XLSX.writeFile(wb, fileName);
            message.success("Inventory report exported successfully!");
        } catch (error) {
            console.error("Error exporting inventory report:", error);
            message.error("Failed to export inventory report");
        } finally {
            setExportLoading(false);
        }
    };

    const getCurrent = useCallback(async () => {
        const today = dayjs();
        const startDate = today.subtract(today.day(), 'day');
        const endDate = today;
        
        formAdd.setFieldsValue({
            startDate: startDate,
            endDate: endDate,
        });
        
        try {
            await fetchStockData(startDate, endDate);
            
            const startEpoch = getGmtStartOfDay(startDate);
            const endEpoch = getGmtEndOfDay(endDate);
            
            const response = await StockApi.ListproductInventryReport(
                startEpoch, 
                endEpoch
            );
            
            PageLoading();
            setWasteReport(response?.payload);
            
            if (response?.payload) {
                extractFilterOptions(response.payload);
            }
        } catch (err) {
            console.log(err);
            if (err.apiError?.status) {
                notification.open({
                    message: (
                        <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                    ),
                    description: err.apiError.message,
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
            }
        }
    }, [fetchStockData]);

    useEffect(() => {
        PageLoading();
        getCurrent();
    }, [PageLoading, getCurrent]);

    const handleSubmit = async (data) => {
        setFilterLoading(true);

        try {
            const startDate = data.startDate;
            const endDate = data.endDate;
            
            await fetchStockData(startDate, endDate);
            
            const startEpoch = getGmtStartOfDay(startDate);
            const endEpoch = getGmtEndOfDay(endDate);
            
            const response = await StockApi.ListproductInventryReport(
                startEpoch, 
                endEpoch
            );
            
            PageLoading();
            setWasteReport(response?.payload);
            
            if (response?.payload) {
                extractFilterOptions(response.payload);
            }
            
            setDepartmentFilter(null);
            setBatchCodeFilter(null);
            setProductNameFilter(null);
            setDdNumberFilter(null);
            setFilteredReport([]);
            
            setFilterLoading(false);
        } catch (err) {
            console.log(err);
            setFilterLoading(false);
            if (err.apiError?.status) {
                notification.open({
                    message: (
                        <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                    ),
                    description: err.apiError.message,
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
            }
        }
    }

    // Reset filters
    const resetFilters = () => {
        setDepartmentFilter(null);
        setBatchCodeFilter(null);
        setProductNameFilter(null);
        setDdNumberFilter(null);
        setFilteredReport([]);
    };

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString("en-US", options);
        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }

    const handleClear = () => {
        setIsLoading(true);
        setTotalQuantity(null);
        setTotalcostPriceUoM1(null);
        setWasteReport([]);
        setFilteredReport([]);
        setOpeningStock(0);
        setClosingStock(0);
        resetFilters();
        setTimeout(() => {
            getCurrent();
            setIsLoading(false);
        }, 800);
    };

    const CurrencyConvert = (value) => {
        if (!value || isNaN(value)) return '0';
        const formattedNumber = new Intl.NumberFormat('en-US').format(value);
        return formattedNumber;
    };

    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader onPrintResponse2={handlePrintButtonClick2} />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}

                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>
                        {/* Stock Summary Section */}
                        <Card 
                            style={{ 
                                marginBottom: '24px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                background: 'linear-gradient(135deg, #f0f7ff 0%, #e6f0fa 100%)'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ 
                                marginBottom: '12px', 
                                borderBottom: '1px solid #d9e8f0', 
                                paddingBottom: '10px'
                            }}>
                                <Space>
                                    <span style={{ fontSize: '16px', fontWeight: 600, color: '#0066a1' }}>
                                        Stock Summary
                                    </span>
                                    <span style={{ fontSize: '12px', color: '#666' }}>
                                    </span>
                                </Space>
                            </div>
                            
                            <Row gutter={[24, 16]}>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{ 
                                        background: 'white', 
                                        padding: '16px', 
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.05)'
                                    }}>
                                        <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                                            Opening Stock
                                        </div>
                                        <div style={{ 
                                            fontSize: '20px', 
                                            fontWeight: 'bold', 
                                            color: '#0066a1'
                                        }}>
                                            {openingStockLoading ? 'Loading...' : `${CURRENCY} ${CurrencyConvert(openingStock)}`}
                                        </div>
                                    </div>
                                </Col>

                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <div style={{ 
                                        background: 'white', 
                                        padding: '16px', 
                                        borderRadius: '8px',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                        border: '2px solid #0066a1'
                                    }}>
                                        <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                                            Closing Stock
                                        </div>
                                        <div style={{ 
                                            fontSize: '22px', 
                                            fontWeight: 'bold', 
                                            color: '#0066a1'
                                        }}>
                                            {openingStockLoading ? 'Loading...' : `${CURRENCY} ${CurrencyConvert(closingStock)}`}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>

                        {/* Filter Section */}
                        <Card 
                            style={{ 
                                marginBottom: '24px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ marginBottom: '16px', borderBottom: '1px solid #f0f0f0', paddingBottom: '10px' }}>
                                <Space>
                                    <FilterOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                                    <span style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>Filter Options</span>
                                </Space>
                            </div>
                            
                            <Form
                                form={formAdd}
                                name="inventory_filter_form"
                                layout="vertical"
                                onFinish={handleSubmit}
                            >
                                <Row gutter={[16, 0]}>
                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            name="startDate"
                                            label="Start Date (Sunday)"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please Select Start Date (Sunday).",
                                                },
                                            ]}
                                        >
                                            <DatePicker
                                                format={"DD/MM/YYYY"}
                                                placeholder="Select Start Date"
                                                style={{ width: '100%', height: '40px' }}
                                                allowClear={false}
                                                suffixIcon={null}
                                                onChange={handleStartDateChange}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            name="endDate"
                                            label="End Date"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please select End Date.",
                                                },
                                            ]}
                                        >
                                            <DatePicker
                                                format={"DD/MM/YYYY"}
                                                placeholder="Select End Date"
                                                style={{ width: '100%', height: '40px' }}
                                                allowClear={false}
                                                suffixIcon={null}
                                                onChange={handleEndDateChange}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col lg={8} md={24} sm={24} xs={24}>
                                        <Form.Item label="Actions">
                                            <Space size="middle" wrap>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    loading={filterLoading}
                                                    icon={<FilterOutlined />}
                                                    style={{ height: '40px', minWidth: '100px' }}
                                                >
                                                    Apply Filter
                                                </Button>
                                                <Button
                                                    onClick={() => handleClear()}
                                                    icon={<ClearOutlined />}
                                                    style={{ height: '40px', minWidth: '100px' }}
                                                >
                                                    Clear
                                                </Button>
                                            </Space>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>

                        {/* Advanced Filters Section */}
                        <Card 
                            style={{ 
                                marginBottom: '24px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                background: '#fafafa'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ marginBottom: '16px', borderBottom: '1px solid #f0f0f0', paddingBottom: '10px' }}>
                                <Space>
                                    <SearchOutlined style={{ fontSize: '18px', color: '#1890ff' }} />
                                    <span style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>Advanced Filters</span>
                                    <span style={{ fontSize: '12px', color: '#999' }}>
                                        (Filter by Department, D.D Number, Product, Batch)
                                    </span>
                                </Space>
                            </div>
                            
                            <Row gutter={[16, 16]}>
                                <Col lg={6} md={12} sm={12} xs={24}>
                                    <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: 500, color: '#555' }}>
                                        Department Name
                                    </div>
                                    <Select
                                        placeholder="All Departments"
                                        style={{ width: '100%' }}
                                        value={departmentFilter}
                                        onChange={setDepartmentFilter}
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {departmentOptions.map(dept => (
                                            <Select.Option key={dept} value={dept}>{dept}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>

                                <Col lg={6} md={12} sm={12} xs={24}>
                                    <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: 500, color: '#555' }}>
                                        D.D Number
                                    </div>
                                    <Select
                                        placeholder="All DD Numbers"
                                        style={{ width: '100%' }}
                                        value={ddNumberFilter}
                                        onChange={setDdNumberFilter}
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {ddNumberOptions.map(dd => (
                                            <Select.Option key={dd} value={dd}>{dd}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>

                                <Col lg={6} md={12} sm={12} xs={24}>
                                    <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: 500, color: '#555' }}>
                                        Product Name
                                    </div>
                                    <Select
                                        placeholder="All Products"
                                        style={{ width: '100%' }}
                                        value={productNameFilter}
                                        onChange={setProductNameFilter}
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {productOptions.map(product => (
                                            <Select.Option key={product} value={product}>{product}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>

                                <Col lg={6} md={12} sm={12} xs={24}>
                                    <div style={{ marginBottom: '4px', fontSize: '13px', fontWeight: 500, color: '#555' }}>
                                        Batch Code
                                    </div>
                                    <Select
                                        placeholder="All Batches"
                                        style={{ width: '100%' }}
                                        value={batchCodeFilter}
                                        onChange={setBatchCodeFilter}
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            option?.children?.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {batchOptions.map(batch => (
                                            <Select.Option key={batch} value={batch}>{batch}</Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                            
                            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
                                <div style={{ padding: '8px 12px', background: '#e6f7ff', borderRadius: '4px', fontSize: '12px', color: '#1890ff' }}>
                                    Showing {displayData.length} of {WasteReport.length} records
                                    {(departmentFilter || ddNumberFilter || productNameFilter || batchCodeFilter) && 
                                        ` (Filtered: ${departmentFilter ? `Department: ${departmentFilter}` : ''}${ddNumberFilter ? `, DD#: ${ddNumberFilter}` : ''}${productNameFilter ? `, Product: ${productNameFilter}` : ''}${batchCodeFilter ? `, Batch: ${batchCodeFilter}` : ''})`
                                    }
                                </div>
                                <Button
                                    onClick={resetFilters}
                                    icon={<ClearOutlined />}
                                    size="small"
                                >
                                    Reset All Filters
                                </Button>
                            </div>
                        </Card>

                        {/* Report Results Section */}
                        <Card 
                            style={{ 
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                            }}
                            bodyStyle={{ padding: '20px' }}
                        >
                            <div style={{ 
                                marginBottom: '16px', 
                                borderBottom: '1px solid #f0f0f0', 
                                paddingBottom: '10px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <Space>
                                    <span style={{ fontSize: '16px', fontWeight: 500, color: '#333' }}>Inventory Report Results</span>
                                    <span style={{ fontSize: '12px', color: '#999' }}>
                                        {displayData.length > 0 && `(${displayData.length} records found)`}
                                    </span>
                                </Space>
                                <Button
                                    type="primary"
                                    onClick={handleExportToExcel}
                                    loading={exportLoading}
                                    icon={<DownloadOutlined />}
                                    style={{ 
                                        height: '36px',
                                        backgroundColor: '#52c41a',
                                        borderColor: '#52c41a'
                                    }}
                                >
                                    Export Inventory Report
                                </Button>
                            </div>
                            
                            <div
                                ref={topScrollRef}
                                style={{
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    height: "16px",
                                    marginBottom: "8px",
                                }}
                            >
                                <div style={{ height: "1px" }} />
                            </div>

                            <div
                                ref={tableScrollRef}
                                className="dateFilterTable"
                                style={{ overflowX: "auto" }}
                            >
                                <table className="table users-table Reportable" style={{ width: '100%', minWidth: '1200px' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan="6"></th>
                                            <th colSpan="2" className="text-center centerClass trBorder">Goods Inward CP1</th>
                                            <th colSpan="2" className="text-center centerClass trBorder">Goods Outward</th>
                                            <th colSpan="2" className="text-center centerClass trBorder">Stock</th>
                                            <th colSpan="2" className="text-center centerClass trBorder">This Week Usage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Opening Stock Row */}
                                        <tr style={{ backgroundColor: '#e6f7ff' }}>
                                            <td className="trBorder" colSpan="6" style={{ fontWeight: 'bold', color: '#0066a1' }}>
                                                OPENING STOCK (as of {formAdd.getFieldValue('startDate') ? dayjs(formAdd.getFieldValue('startDate')).format('DD/MM/YYYY') : ''})
                                            </td>
                                            <td className="trBorder"></td>
                                            <td className="trBorder" style={{ fontWeight: 'bold', color: '#0066a1' }}>
                                                {CURRENCY} {CurrencyConvert(openingStock)}
                                            </td>
                                            <td className="trBorder"></td>
                                            <td className="trBorder"></td>
                                            <td className="trBorder"></td>
                                            <td className="trBorder"></td>
                                        </tr>
                                        
                                        <tr>
                                            <th className="trBorder text-center ">Date</th>
                                            <th className="trBorder text-center">D.D Number</th>
                                            <th className="trBorder text-center">Department Name</th>
                                            <th className="trBorder text-center">Supplier Name</th>
                                            <th className="trBorder text-center">Batch Code</th>
                                            <th className="trBorder text-center">Product Name</th>
                                            <th className="trBorder text-center">Added Qty (UOM2)</th>
                                            <th className="trBorder text-center">Cost (UOM2)</th>
                                            <th className="trBorder text-center">Used Qty (UOM2)</th>
                                            <th className="trBorder text-center">Cost (UOM2)</th>
                                            <th className="trBorder text-center">Available Qty (UOM2)</th>
                                            <th className="trBorder text-center">Cost (UOM2)</th>
                                            <th className="trBorder text-center">This Week Used Qty(UOM2)</th>
                                            <th className="trBorder text-center">This Week Used Cost (UOM2)</th>
                                        </tr>

                            {displayData.map((date, index) => {
                                const maxStockCount = date?.goodsInwardDTO?.stockList
                                    ? date.goodsInwardDTO.stockList.length
                                    : 0;

                                return Array.from({ length: maxStockCount }).map((_, innerIndex) => {
                                    const stock = date?.goodsInwardDTO?.stockList[innerIndex];
                                    if (!stock) return null;
                                    console.log(stock, "stock");

                                    const costPrice = parseFloat(stock?.productDTOs?.[0]?.costPriceUoM2) || 0;
                                    const addedInDateRange = isStockCreatedDateInRange(stock);

                                    // --- Inward / Stock figures (only for non-usage rows) ---
                                    const initQuantity = parseFloat(stock?.initQuantity) || 0;
                                    const availableQty = parseFloat(stock?.unitOfMeasurement1) || 0;
                                    const inwardValue =  addedInDateRange ? initQuantity * costPrice : 0;
                                    const outwardValue = (initQuantity - availableQty) * costPrice;
                                    const stockValue = availableQty * costPrice;

                                    // --- This-week usage figures (only for usage rows) ---
                                    const usedQty =  parseFloat(stock?.usedQuantity) || 0;
                                    const usedCost = parseFloat(stock?.usedCost) || usedQty * costPrice;

                                    // Format helper (truncate to 2 dp like original)
                                    const fmtQty = (v) => {
                                        const s = Number(v || 0).toLocaleString("fullwide", {
                                            useGrouping: false,
                                            maximumFractionDigits: 20,
                                        });
                                        const m = s.match(/^-?\d+(?:\.\d{0,2})?/);
                                        return m ? m[0] : "0";
                                    };

                                    return (
                                        <tr key={`${index}-${innerIndex}`}>
                                            <td className="trBorder text-center">
                                                {innerIndex === 0 ? formatDate(date?.goodsInwardDTO?.goodInwardCreateDate) : ''}
                                            </td>
                                            <td className="trBorder text-center">
                                                {innerIndex === 0 ? date?.goodsInwardDTO?.deliveryDocketNumber : ''}
                                            </td>
                                            <td className="CleanTable trBorder text-center">
                                                {innerIndex === 0 ? date?.goodsInwardDTO?.institutionDTO?.institutionName : ''}
                                            </td>
                                            <td className="CleanTable trBorder text-center">
                                                {innerIndex === 0 ? date?.goodsInwardDTO?.supplierDTO?.supplierName : ''}
                                            </td>
                                            <td className="CleanTable trBorder text-center">
                                                <div style={{
                                                    overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap',
                                                    maxWidth: '200px', marginBottom: '10px', marginTop: '-3px',
                                                    padding: '0px 0px 20px', display: 'block',
                                                }}>
                                                    {stock?.batchCode}
                                                </div>
                                            </td>
                                            <td className="CleanTable trBorder text-center">
                                                {stock?.productDTOs?.[0]?.productName}
                                            </td>

                                            {/* --- Goods Inward CP1 --- */}
                                            <td className="CleanTable trBorder text-center">
                                               {addedInDateRange ? `${initQuantity} ${stock?.unit || ''}` : ''}
                                            </td>
                                            <td className="CleanTable trBorder text-center">
                                                   {addedInDateRange ? `${CURRENCY} ${CurrencyConvert(inwardValue)}` : ''}
                                            </td>

                                            {/* --- Goods Outward (derived from inward vs available) --- */}
                                            <td className="CleanTable trBorder text-center">
                                                {addedInDateRange ? `${fmtQty(initQuantity - availableQty)} ${stock?.unit || ''}` : ''}
                                            </td>

                                            <td className="CleanTable trBorder text-center">
                                                {addedInDateRange ? `${CURRENCY} ${outwardValue.toFixed(2)}` : ''}
                                            </td>

                                            {/* --- Stock --- */}
                                            <td className="CleanTable trBorder text-center">
                                                {  `${fmtQty(availableQty)} ${stock?.unit || ''}`}
                                            </td>
                                            
                                            <td className="CleanTable trBorder text-center">
                                                {  `${CURRENCY} ${CurrencyConvert(stockValue)}`}
                                            </td>

                                            {/* --- This Week Usage (from usedQuantity/usedCost) --- */}
                                            <td className="CleanTable trBorder text-center">
                                                { `${fmtQty(usedQty)} ${stock?.unit || ''}`}
                                            </td>
                                            <td className="CleanTable trBorder text-center">
                                                { `${CURRENCY} ${CurrencyConvert(usedCost)}`}
                                            </td>
                                        </tr>
                                    );
                                });
                            })}
                                    </tbody>
                                    <thead>
                                        <tr>
                                            <th className="text-end trBorder text-center" colSpan="7">Total</th>
                                            <th className="text-end trBorder text-center">{CURRENCY} {CurrencyConvert(totalValue)}</th>
                                            <th className="text-end trBorder text-center">Total</th>
                                            <th className="text-end trBorder text-center">{CURRENCY} {CurrencyConvert(totalValue4)}</th>
                                            <th className="text-end trBorder text-center"></th>
                                            <th className="text-end trBorder text-center">{}</th>

                                            <th className="text-end trBorder text-center">Total</th>
                                            <th className="text-end trBorder text-center">{CURRENCY} {CurrencyConvert(totalValue2)}</th>
                                        </tr>
                                        {/* Closing Stock Row */}
                                        <tr style={{ backgroundColor: '#f6ffed' }}>
                                            <th className="text-end trBorder text-center" colSpan="9" style={{ fontWeight: 'bold', color: '#0066a1' }}>
                                                CLOSING STOCK
                                            </th>
                                            <th className="text-end trBorder text-center" style={{ fontWeight: 'bold', color: '#0066a1' }}>
                                                {CURRENCY} {CurrencyConvert(closingStock)}
                                            </th>
                                            <th className=" text-center text-end trBorder"></th>
                                            <th className=" text-center text-end trBorder"></th>
                                            <th className=" text-center text-end trBorder"></th>
                                            <th className=" text-center text-end trBorder"></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </Card>
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default InventoryReports;